namespace Nobox.CRM {
    export interface DealpipelinesRow {
        Id?: number;
        AliasId?: number;
        Nm?: string;
        PrivacyVisibility?: string;
        Description?: string;
        AliasNm?: string;
        RatingStatus?: string;
        RatingStatusPeriod?: string;
        TypeList?: DealpipelinetypesRow[];
        TypeListDel?: DealpipelinetypesRow[];
        Act?: string;
        GrpId?: number;
        Tags?: number;
        In?: string;
        InBy?: number;
        Up?: string;
        UpBy?: number;
        InByNm?: string;
        UpByNm?: string;
    }

    export namespace DealpipelinesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Nm';
        export const localTextPrefix = 'Nobox.Dealpipelines';
        export const deletePermission = 'Deals:Delete';
        export const insertPermission = 'Deals:Modify';
        export const readPermission = 'Deals:View';
        export const updatePermission = 'Deals:Modify';

        export declare const enum Fields {
            Id = "Id",
            AliasId = "AliasId",
            Nm = "Nm",
            PrivacyVisibility = "PrivacyVisibility",
            Description = "Description",
            AliasNm = "AliasNm",
            RatingStatus = "RatingStatus",
            RatingStatusPeriod = "RatingStatusPeriod",
            TypeList = "TypeList",
            TypeListDel = "TypeListDel",
            Act = "Act",
            GrpId = "GrpId",
            Tags = "Tags",
            In = "In",
            InBy = "InBy",
            Up = "Up",
            UpBy = "UpBy",
            InByNm = "InByNm",
            UpByNm = "UpByNm"
        }
    }
}
